<div class="sidebar-content global-filter">
  <div class="sidebar-header ">
    <h2>Filters</h2>
    <button class="clear-filters" title="Clear filters" (click)="clear()" [disabled]="!isFiltered">
      <svg class="svg-16 blue"><use xlink:href="#icon-clearfilter"></use></svg>
    </button>
    <button class="close-sidebar" title="Close the filters pane" (click)="close()" *ngIf="isCloseButtonVisible">
      <svg class="svg-16 blue"><use xlink:href="#icon-cancel"></use></svg>
    </button>
    <button class="clear-all-sections" (click)="clear()">
      <svg><use xlink:href="#icon-clear"></use></svg>Clear All
    </button>
  </div>

  <p class="total-filters">{{itemCount}} items</p>
  <ng-container *ngIf="isThereAnyItem">
    <ng-container *ngFor="let property of properties">
      <ng-container [ngSwitch]="property.Type">
        <app-string-filter *ngSwitchCase="'string'"
          [property]="property"
          filterMode="MultipleProperties"
          [filterService]="filterService"
          [mode]="mode"
          (filterChanged)="emitFilterChanged()">
        </app-string-filter>
        <app-string-filter *ngSwitchCase="'People'"
          [property]="property"
          filterMode="MultipleProperties"
          [filterService]="filterService"
          [mode]="mode"
          (filterChanged)="emitFilterChanged()">
        </app-string-filter>
        <app-string-filter *ngSwitchCase="'number'"
          [property]="property"
          filterMode="MultipleProperties"
          [filterService]="filterService"
          (filterChanged)="emitFilterChanged()">
        </app-string-filter>
        <app-date-filter *ngSwitchCase="'Date'"
          [property]="property"
          filterMode="MultipleProperties"
          [filterService]="filterService"
          [mode]="mode"
          (filterChanged)="emitFilterChanged()">
        </app-date-filter>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
